<h4 class="custom-bold">Summary</h4>
<p-card>
    <div class="flex flex-row justify-content-between">
        <p class="mt-0 mb-0">{{paymentInitiation === 'serviceRequestInitiation' ? 'Total' : 'Amount due'}}</p>
        <strong data-auto-id="make-payment-vivr-amount-due">
            {{amountToPay | currency:'USD':'symbol-narrow'}}
        </strong>
    </div>
</p-card>
